<template>
  <section class="bt-payment-history" aria-live="polite">
    <h4>{{$t('btPayments.title')}}</h4>
    <button class="btn btn-info" :disabled="loading" @click.prevent="load(page)">{{$t('btPayments.refresh')}}</button>
    <p v-if="loading">{{$t('btPayments.processing')}}</p>
    <p v-if="error" class="text-danger" role="alert">{{error}}</p>
    <div v-if="!error" class="table-responsive">
      <table class="table table-striped">
        <thead><tr>
          <th>ID</th><th>{{$t('btPayments.reference')}}</th><th>{{$t('btPayments.mode')}}</th>
          <th>{{$t('btPayments.state')}}</th><th>{{$t('btPayments.amount')}}</th>
          <th>{{$t('btPayments.capturedAmount')}}</th><th>{{$t('btPayments.returnedAmount')}}</th><th>{{$t('btPayments.details')}}</th>
        </tr></thead>
        <tbody>
          <tr v-for="payment in payments" :key="payment.id">
            <td>{{payment.id}}</td>
            <td><div>{{payment.reference}}</div><small>{{payment.payable_type}} #{{payment.payable_id}}</small></td>
            <td>{{payment.payment_type}}<br><small>{{payment.environment}}</small></td>
            <td>
              <strong :class="payment.attention_required ? 'text-danger' : ''">{{$t('btPayments.' + statusKey(payment.status))}}</strong>
              <div v-if="payment.attention_required" class="text-danger">{{$t('btPayments.review')}}</div>
              <div v-if="payment.cancel_requested_at && ![5, 6].includes(Number(payment.status))" class="text-warning">{{$t('btPayments.returnPending')}}</div>
              <small>{{payment.applied_at ? $t('btPayments.applied') : $t('btPayments.notApplied')}}</small>
              <p v-if="payment.error_message" class="text-danger">{{payment.error_message}}</p>
            </td>
            <td>{{amount(payment.amount_minor, payment.currency)}}</td>
            <td>{{amount(payment.captured_minor, payment.currency)}}</td>
            <td>{{amount(payment.refunded_minor, payment.currency)}}</td>
            <td><button class="btn btn-sm btn-default" @click.prevent="selected = selected && selected.id === payment.id ? null : payment">{{$t('btPayments.details')}}</button></td>
          </tr>
          <tr v-if="!loading && !payments.length"><td colspan="8">{{$t('btPayments.empty')}}</td></tr>
        </tbody>
      </table>
    </div>
    <div v-if="selected" class="well">
      <button class="btn btn-sm pull-right" @click.prevent="selected = null">{{$t('btPayments.close')}}</button>
      <p>{{$t('btPayments.payment')}} #{{selected.id}} — {{selected.reference}}</p>
      <p>{{$t('btPayments.transaction')}}: {{selected.gateway_transaction_id || '—'}}</p>
      <p>{{$t('btPayments.approved')}}: {{amount(selected.approved_minor, selected.currency)}}</p>
      <p>{{$t('btPayments.cancelRequested')}}: {{selected.cancel_requested_at || '—'}}</p>
      <p>{{$t('btPayments.fulfilled')}}</p>
    </div>
    <div v-if="!error" class="text-right">
      <button class="btn btn-sm" :disabled="loading || page <= 1" @click.prevent="load(page - 1)">{{$t('btPayments.previous')}}</button>
      <span>{{$t('btPayments.page')}} {{page}} / {{lastPage}}</span>
      <button class="btn btn-sm" :disabled="loading || page >= lastPage" @click.prevent="load(page + 1)">{{$t('btPayments.next')}}</button>
    </div>
  </section>
</template>
<script>
import {btStatusKey, btAmount, btApiError} from 'src/utils/btPayments'
export default {
  props: {companyId: {required: true}},
  data () { return {payments: [], selected: null, page: 1, lastPage: 1, loading: false, error: '', requestId: 0} },
  watch: {companyId: {immediate: true, handler () { this.payments = []; this.selected = null; this.load(1) }}},
  beforeDestroy () { this.requestId++ },
  methods: {
    statusKey: btStatusKey,
    amount: btAmount,
    load (page) {
      if (!this.companyId) return
      const requestId = ++this.requestId
      this.loading = true
      this.error = ''
      this.selected = null
      this.apiRequest('/bt-ipay/payments', 'GET', {
        token: this.$session.get('token'), company_id: this.companyId, page: page
      }, response => {
        if (requestId !== this.requestId) return
        this.loading = false
        const result = response && response.data
        if (!result || !Array.isArray(result.data)) {
          this.payments = []
          this.error = btApiError(response, this.$t('btPayments.loadError'))
          return
        }
        this.payments = result.data
        this.page = Number(result.current_page) || page
        this.lastPage = Number(result.last_page) || 1
      })
    }
  }
}
</script>
<style scoped>
.bt-payment-history { margin-top: 25px; border-top: 1px solid #ddd; padding-top: 15px; }
.bt-payment-history td { vertical-align: top; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/PaymentGroups/BtPaymentHistory.vue